"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));

var _placements = require("./utils/placements");

require("./Popover.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DEFAULT_PLACEMENT = 'top';
var Popover = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
      visible = props.visible,
      defaultVisible = props.defaultVisible,
      onVisibleChange = props.onVisibleChange,
      overlayClassName = props.overlayClassName,
      title = props.title,
      content = props.content,
      placement = props.placement,
      trigger = props.trigger;
  var childElement = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(!!visible || !!defaultVisible),
      _useState2 = _slicedToArray(_useState, 2),
      localVisible = _useState2[0],
      setLocalVisible = _useState2[1];

  (0, _react.useEffect)(function () {
    if ('visible' in props) {
      setLocalVisible(visible);
    }
  }, [visible]);

  var isNoTitle = function isNoTitle() {
    return !title && !content && title !== 0;
  };

  var handleVisibleChange = function handleVisibleChange(vis) {
    if (!('visible' in props)) {
      setLocalVisible(isNoTitle() ? false : vis);
    }

    if (onVisibleChange && !isNoTitle()) {
      onVisibleChange(vis);
    }
  };

  var observerPopover = (0, _react.useMemo)(function () {
    return new global.MutationObserver(function (event) {
      try {
        var domNode = Array.isArray(event) && event[0] && event[0].target;

        if (domNode) {
          var rect = domNode.getBoundingClientRect();
          var arrowEl = domNode.querySelector('.rc-tooltip-arrow');
          var childElementRect = childElement.current.getBoundingClientRect();

          if (placement.indexOf('top') >= 0 || placement.indexOf('bottom') >= 0) {
            arrowEl.style.left = "".concat(childElementRect.left - rect.left + childElementRect.width / 2, "px");
          }
        }
      } catch (e) {
        console.warn(e);
      }
    });
  }, []);

  var onPopupAlign = function onPopupAlign(domNode) {
    observerPopover.observe(domNode, {
      attributes: true,
      attributeFilter: ['style']
    });
  };

  var renderOverlay = function renderOverlay() {
    if (title === 0) {
      return title;
    }

    return content || title || '';
  };

  var getOverlay = function getOverlay() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement("div", {
      className: "rc-tooltip-title"
    }, renderOverlay()), content && /*#__PURE__*/_react.default.createElement("div", {
      className: "rc-tooltip-inner-content"
    }, renderOverlay()));
  };

  var getVisible = function getVisible(vis) {
    if (!('visible' in props) && isNoTitle()) {
      return false;
    }

    return vis;
  };

  (0, _react.useEffect)(function () {
    if (localVisible === false) {
      observerPopover.disconnect();
    }
  }, [localVisible]);
  return /*#__PURE__*/_react.default.createElement(_rcTooltip.default, _extends({}, props, {
    overlayClassName: "Popover ".concat(overlayClassName),
    placement: (0, _placements.validatePlacement)(placement, DEFAULT_PLACEMENT),
    trigger: trigger,
    ref: ref,
    visible: getVisible(localVisible),
    arrowContent: /*#__PURE__*/_react.default.createElement("span", {
      className: "rc-tooltip-arrow-content"
    }),
    onPopupAlign: onPopupAlign,
    onVisibleChange: handleVisibleChange,
    overlay: getOverlay(),
    destroyPopupOnHide: true
  }), /*#__PURE__*/_react.default.createElement("span", {
    ref: childElement
  }, children));
});
Popover.propTypes = {
  /** Title of the card */
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),

  /** Content of the card */
  content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),

  /** Whether the floating tooltip card is visible by default */
  defaultVisible: _propTypes.default.bool,

  /** Whether the floating tooltip card is visible by default */
  // eslint-disable-next-line react/require-default-props
  visible: _propTypes.default.bool,

  /** Callback executed when visibility of the tooltip card is changed */
  onVisibleChange: _propTypes.default.func,

  /** The position of the tooltip relative to the target,
   *  which can be one of top left right bottom topLeft
   *  topRight bottomLeft bottomRight leftTop leftBottom
   *  rightTop rightBottom */
  placement: _propTypes.default.string,

  /** Popover trigger mode. Could be multiple by passing an array
   * which actions cause tooltip shown. enum of 'hover','click','focus' */
  trigger: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),

  /** Whether the arrow is pointed at the center of target */
  arrowPointAtCenter: _propTypes.default.bool,

  /** Whether to adjust popup placement automatically when popup is off screen */
  autoAdjustOverflow: _propTypes.default.bool,

  /** @ignored */
  overlayClassName: _propTypes.default.string,

  /** @ignored */
  children: _propTypes.default.node
};
Popover.defaultProps = {
  title: null,
  content: null,
  defaultVisible: false,
  onVisibleChange: null,
  placement: 'top',
  trigger: ['hover'],
  arrowPointAtCenter: false,
  autoAdjustOverflow: true,
  overlayClassName: '',
  children: null
};
var _default = Popover;
exports.default = _default;